import { render, staticRenderFns } from "./ManageStatusFlow.vue?vue&type=template&id=cfecd9fa&scoped=true&lang=pug&"
import script from "./ManageStatusFlow.vue?vue&type=script&lang=js&"
export * from "./ManageStatusFlow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfecd9fa",
  null
  
)

export default component.exports